import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { TableActions } from "../../../components/tables/tableContext/TableContext";
import { fetchAssignedCarsNode } from "../../../redux/api/fleet.api";
import {
  assignedCarsNodeTableHeader,
  getAssignedCarsNodeTableData,
} from "./components/tableConfigs/assignedCarsTableConfig";
import TableWidget from "../../../components/tables/TableWidget";
import { useCallback, useEffect, useMemo } from "react";
import { getWorkingRoutesNodes } from "../../../redux/api/expedition.api";
import TableCustomHeader from "./components/TableCustomHeader";
import AssignCarsToNodeActionButton from "./components/TableActionsButtonsComponents/FleetActionButton";

function AssignCarToNode() {
  const dispatch = useAppDispatch();

  const {
    assignedCars: {
      fleetAllAssignedCarsToNode: {
        data: { data: fleetAllAssignedCarsToNodeData, total },
        isLoading: isLoadingFleetAllAssignedCarsToNode,
      },
    },
    expedition: {
      workingRoutesNodes: {
        data: { data: clientsNodesData },
      },
    },
  } = useAppSelector((state) => ({
    expedition: state.expedition,
    assignedCars: state.fleet,
  }));

  useEffect(() => {
    dispatch(getWorkingRoutesNodes({ page: 1, perPage: 1000 }));
  }, [dispatch]);

  const getHistoryTableHeaderNew = useCallback(
    (initialTableData: any[]) => {
      return initialTableData.map((item) => {
        if (item.value === "id_nod") {
          const nodesDropdown = clientsNodesData?.map(
            ({ nodNume, id_nod }) => ({
              label: nodNume,
              value: id_nod,
            }),
          );
          return {
            withFilter: [{ label: "Toate", value: 0 }, ...nodesDropdown],
            ...item,
          };
        }

        return item;
      });
    },
    [clientsNodesData],
  );

  const handleTableActions = (action: TableActions) => {
    if (action.tablePagination.page && action.tablePagination.rowsPerPage) {
      dispatch(
        fetchAssignedCarsNode({
          page: action.tablePagination.page,
          perPage: action.tablePagination.rowsPerPage,
          nrauto: action.tableSearch.nrauto,
          id_nod: action.tableFilter.id_nod,
        }),
      );
    }
  };

  const assignedCarsNodeTableHeaderNew = useMemo(
    () => getHistoryTableHeaderNew(assignedCarsNodeTableHeader),
    [getHistoryTableHeaderNew],
  );

  return (
    <TableWidget
      CustomHeaderComponent={TableCustomHeader}
      tableHeaderData={assignedCarsNodeTableHeaderNew}
      tableItemsData={getAssignedCarsNodeTableData(
        fleetAllAssignedCarsToNodeData,
      )}
      totalItems={total}
      borderedRow
      tableLoading={isLoadingFleetAllAssignedCarsToNode}
      ActionButtonsComponent={AssignCarsToNodeActionButton}
      handleTableActions={handleTableActions}
    />
  );
}

export default AssignCarToNode;
